import React from 'react'
import type { ReactNode } from 'react'
import * as S from './styled'

export type BaseContentProps = {
  size?: 'xsmall' | 'small' | 'base'
  appearance?: 'primary' | 'secondary'
  bold?: boolean
  children: ReactNode
}

export const BaseContent = ({
  size = 'base',
  appearance = 'primary',
  bold = false,
  children,
}: BaseContentProps) => (
  <S.Container $size={size} $appearance={appearance} $bold={bold}>
    {children}
  </S.Container>
)
